import AnimationKillswitch from './AnimationKillswitch';

export default AnimationKillswitch;
